<template>
    <div
        v-if="errors !== undefined && errors !== null"
        class="invalid-feedback d-block"
    >
        <span
            v-for="(error, key) of errors"
            :key="key"
        >
            {{ error }}
        </span>
    </div>
</template>

<script>
    export default {
        name: "BaseError",

        props: {
            errors: {type: Array, default: () => []},
        },
    }
</script>
